import { NavLink } from 'react-router-dom';

export default function NavButton({ to, icon: Icon, label, collapsed, onClick }) {
  return (
    <NavLink
      to={to}
      onClick={onClick}
      className={({ isActive }) => {
        const base =
          'group relative my-0.5 flex items-center overflow-hidden rounded-2xl transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-300/70';
        const sizing = collapsed ? 'justify-center px-0 py-1.5' : 'gap-2.5 px-3 py-1.5';
        const state = isActive
          ? 'border border-transparent bg-white/95 text-slate-900 shadow-[0_16px_45px_rgba(15,23,42,0.25)] dark:bg-white dark:text-slate-950'
          : 'border border-transparent text-slate-500 hover:bg-slate-900/5 hover:text-slate-900 dark:text-slate-300 dark:hover:bg-white/5 dark:hover:text-white';
        return `${base} ${sizing} ${state}`;
      }}
    >
      {({ isActive }) => (
        <>
          {!collapsed && (
            <span
              className={`absolute inset-y-2 left-2 w-1 rounded-full bg-gradient-to-b from-emerald-400 to-sky-400 transition-opacity duration-200 ${
                isActive ? 'opacity-100' : 'opacity-0 group-hover:opacity-70'
              }`}
              aria-hidden
            />
          )}
          <span
            className={`relative flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-xl transition-all duration-200 ${
              isActive
                ? 'bg-gradient-to-br from-emerald-400/90 via-sky-400/80 to-blue-500/70 text-slate-900'
                : 'bg-slate-900/5 text-slate-500 group-hover:text-emerald-400 dark:bg-white/5 dark:text-slate-300'
            }`}
          >
            <Icon className="h-5 w-5" />
          </span>
          {!collapsed && (
            <span
              className={`relative ml-1 flex-1 truncate text-sm font-semibold tracking-tight transition-colors ${
                isActive ? 'text-slate-900 dark:text-slate-950' : 'text-slate-600 dark:text-slate-100'
              }`}
            >
              {label}
            </span>
          )}
        </>
      )}
    </NavLink>
  );
}
